import { Bookmarks } from '@heardis/api-contracts';

export const key = 'bookmarks';

export type State = Bookmarks;

export const initialState: State = {};
